import {Shower} from "../../parts/shower";
import Walls from "../../parts/walls";
import {IntermediatePart} from "../../intermediatePart";

export default class ShowerWallMirror extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = "shower_wall_mirror";
    this.partName = "Shower Wall Mirror";
  }

  load(dbFeature) {
    dbFeature.metaData["MatchingWallName"] = dbFeature.metaData["ActualDisplayedName"];
    return super.load_(dbFeature, new ShowerWallMirror());
  }

  setLayers(layout) {
    const showerParent = layout.parts[Shower.id];
    if (!showerParent || !showerParent.showerWall || !showerParent.showerWall.activeFeature || showerParent.showerWall.disabled) {
      super.hideLayers();
      return;
    }
    super.setLayers(layout);
  }

  getArrayOfConditions() {
    const conditions = super.getArrayOfConditions();
    const layout = this.getParent().layout;
    const showerParent = layout.parts[Shower.id];
    const wallParent = layout.parts[Walls.id];

    const showerSize = showerParent ? showerParent.showerSize() : null;
    if (showerSize) {
      conditions.push({
        propName: "ShowerSize",
        propValue: showerSize
      })
    }
    if (wallParent && wallParent.splitWall) {
      conditions.push({
        propName: "SplitWallType",
        propValue: wallParent.getSplitWallType()
      })
    }
    if (showerParent && showerParent.showerWall && showerParent.showerWall.activeFeature) {
      conditions.push({
        propName: "MatchingWallName",
        propValue: showerParent.showerWall.activeFeature.dbFeature.sharedFeatureName
      })
    }
    return conditions
  }

}
